// extracted by mini-css-extract-plugin
module.exports = {"block":"Infinity--block--11Y8_"};